<template>

  <div class="pesquisa xl:h-screen" >

    <!-- HEADER DESCKTOP -->
    <div class="header descktop" style="background-image: url('../../assets/images/novaintegracao/header-bg.png');">
      <div class="grid grid-cols-3 flex-wrap justify-between topo">
        <div class="my-auto mx-auto">
          <img class="my-auto responsive" src="@/assets/images/novaintegracao/logo-nova.svg" alt="logo nova"/>
        </div>

        <div class="mx-auto my-auto text-center text-white">
          <p style="color:#E0A372;">PASSO SEIS</p>
          <h3 class="text-white">Avaliação do <strong>Conteúdo</strong></h3>
        </div>

        <div class="flex my-auto mx-auto ">
          <h3 class="my-auto text-white">
            Olá
            <strong>{{userisloged.name}}</strong>
          </h3>
          <img class="ml-3" src="@/assets/images/novaintegracao/avatar-novo.svg" alt="avatar"/>
        </div>
      </div>
    </div>

     <!-- HEADER MOBILE -->


    <div class="header mobile mb-10" style="background-image: url('../../assets/images/novaintegracao/header-bg.png');">
      <div class=" flex flex-wrap justify-between topo">

        <div class="w-1/2 my-auto mx-auto">
          <img class="my-auto responsive" src="@/assets/images/novaintegracao/logo-nova.svg" alt="logo nova"/>
        </div>


        <div class="flex my-auto mx-auto ">
            <img class="ml-3 responsive" src="@/assets/images/novaintegracao/avatar-novo.svg" alt="avatar"/>
        </div>

         <div class="mx-auto my-auto text-center text-white">
          <p style="color:#E0A372;">PASSO SEIS</p>
          <h3 class="text-white text-xl md:text-2xl">Avaliação do <strong>Conteúdo</strong></h3>
        </div>

      </div>
    </div>

     <!-- CONTEUDO -->



    <div class="container">

      <h1 class="text-center roboto text-white text-xl md:text-2xl lg:text-3xl ">{{perguntas[perguntaAtual].titulo}}</h1>

      <div class="cards  grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4  gap-10  my-10 py-10">

        <div class="flex sm:flex-col  card card-questionario max-w-sm rounded overflow-hidden bg-white p-5 justify-center items-center mx-auto text-center w-full" v-for=" (resposta , index) in perguntas[perguntaAtual].respostas" :key="index" :class="{'bg-select' : escolhas[perguntaAtual] === index}" @click="setEscolha(index)">

          <img class="responsive w-2/2" :src="get_img_api_public(resposta.imagem)" alt="Sunset in the mountains"/>

          <div class="px-6 py-4 w-2/2">
            <div class="font-bold text-base md:text-xl   mb-2">{{resposta.texto}}  </div>
            <span class="none" v-show="teste > 10">{{teste}}</span>
          </div>

        </div>

      </div>

      <div class="footer h-full container flex flex-col">

        <div class="flex py-5  mx-auto text-center">
          <button class="btn-back roboto md:text-lg p-2 md:p-4 mx-2 " @click="backQuestion()" v-if="perguntaAtual - 1 >= 0">VOLTAR</button>
          <button class="btn-back roboto md:text-lg p-2 md:p-4 mx-2 " @click="voltar()" v-else>VOLTAR</button>
          <button class="btn-next roboto md:text-lg p-2 md:p-4 mx-2 " :class="{'btn-disabled' : !(escolhas[perguntaAtual] >= 0)}" :disabled="!(escolhas[perguntaAtual] >= 0)" @click="nextQuestion"  v-if="perguntaAtual + 1 < perguntas.length">AVANÇAR</button>
          <button class="btn-next roboto md:text-lg p-2 md:p-4 mx-2 font-bold" @click="finalizar"  v-else>Finalizar</button>
        </div>

      </div>

      <div class="conter text-center text-white py-10">
        <h1 class="text-white font-black">{{perguntaAtual +1}}<span class="vermelhowdc"> / </span>10</h1>
      </div>

    </div>
  </div>
</template>

<script>

  export default {
    name: "Produtos",
    props: [],
    created() {

    },
    data() {
      return {
        pronome: 'a',
        animation_path: [],
        width: window.innerWidth,
        teste: null,
        perguntaAtual: 0,
        escolhas:[],
        perguntas:[
          {
            titulo:'Qual o principal objetivo que a empresa quis alcançar ao lançar este Culture Code?',
            respostas:[
              {
                imagem:'respostas/1-1.png',
                texto:'Criar demanda para o designer'
              },
              {
                imagem:'respostas/1-2.png',
                texto:'Mostrar que a impressão ficou um luxo'
              },
              {
                imagem:'respostas/1-3.png',
                texto:'Mostrar os valores, a equipe, nossas metas e conquistas'
              },
              {
                imagem:'respostas/1-4.png',
                texto:'Incentivar a leitura no Brasil'
              },
            ]
          },
          {
            titulo:'O Culture Code é:',
            respostas:[
              {
                imagem:'respostas/1-1.png',
                texto:'Manual de regras rígidas a serem seguidas à risca'
              },
              {
                imagem:'respostas/1-2.png',
                texto:'Um guia prático de leitura de Harry Potter'
              },
              {
                imagem:'respostas/1-3.png',
                texto:'Uma revista de moda'
              },
              {
                imagem:'respostas/1-4.png',
                texto:'Demonstrativo de crenças, valores e princípios da empresa'
              },
            ]
          },
          {
            titulo:'Qual é alternativa correta?',
            respostas:[
              {
                imagem:'respostas/1-1.png',
                texto:'Gostamos de proatividade e responsabilidade'
              },
              {
                imagem:'respostas/1-2.png',
                texto:'Incentivamos intrigas entre colaboradores'
              },
              {
                imagem:'respostas/1-3.png',
                texto:'Seguir nossos princípios é opcional'
              },
              {
                imagem:'respostas/1-4.png',
                texto:'O foco da equipe é a competição interna'
              },
            ]
          },
          {
            titulo:'O que significa a cultura da empresa?',
            respostas:[
              {
                imagem:'respostas/1-1.png',
                texto:'Shows gratuitos e happy hours patrocinados pela empresa'
              },
              {
                imagem:'respostas/1-2.png',
                texto:'Um departamento específico e cultural'
              },
              {
                imagem:'respostas/1-3.png',
                texto:'Um meio de unir pessoas em prol de um propósito'
              },
              {
                imagem:'respostas/1-4.png',
                texto:'Ingressos de cinema entregues pelo RH'
              },
            ]
          },
          {
            titulo:'Qual alternativa está errada?',
            respostas:[
              {
                imagem:'respostas/1-1.png',
                texto:'Não terceirizamos problemas, nós resolvemos'
              },
              {
                imagem:'respostas/1-2.png',
                texto:'Entregamos ao cliente aquilo que ele realmente quer'
              },
              {
                imagem:'respostas/1-3.png',
                texto:'Nosso uniforme é padrão para que ninguém se destaque'
              },
              {
                imagem:'respostas/1-4.png',
                texto:'Temos a mente aberta para novos desafios'
              },
            ]
          },
          {
            titulo:'Assinale a alternativa correta a respeito do que queremos na empresa:',
            respostas:[
              {
                imagem:'respostas/1-1.png',
                texto:'Desrespeito e falta de companheirismo '
              },
              {
                imagem:'respostas/1-2.png',
                texto:'Inimizades e competitividade '
              },
              {
                imagem:'respostas/1-3.png',
                texto:'Preguiça e corpo-mole na hora de trabalhar'
              },
              {
                imagem:'respostas/1-4.png',
                texto:'Respeito e admiração entre os setores, independente da área'
              },
            ]
          },
          {
            titulo:'Fazem parte das nossas listas de valores::',
            respostas:[
              {
                imagem:'respostas/1-1.png',
                texto:'Honestidade, empatia e foco'
              },
              {
                imagem:'respostas/1-2.png',
                texto:'Autodesenvolvimento, comprometimento e honestidade'
              },
              {
                imagem:'respostas/1-3.png',
                texto:'Gratidão, honestidade e consistência'
              },
              {
                imagem:'respostas/1-4.png',
                texto:'Resiliência, atitude e congruência'
              },
            ]
          },
          {
            titulo:'Buscamos contratar pessoas que:',
            respostas:[
              {
                imagem:'respostas/1-1.png',
                texto:'Se vitimiza e sempre apresenta desculpas '
              },
              {
                imagem:'respostas/1-2.png',
                texto:'Gente que adora criar atritos e competitividade '
              },
              {
                imagem:'respostas/1-3.png',
                texto:'Pessoas esforçadas e competentes nas suas funções'
              },
              {
                imagem:'respostas/1-4.png',
                texto:'Parentes desonestos e que não seguem regras'
              },
            ]
          },
          {
            titulo:'A empresa começou, de fato, em:',
            respostas:[
              {
                imagem:'respostas/1-1.png',
                texto:'Em 1918'
              },
              {
                imagem:'respostas/1-2.png',
                texto:'Quando o Titanic se chocou a um iceberg'
              },
              {
                imagem:'respostas/1-3.png',
                texto:'Em dezembro de 2013'
              },
              {
                imagem:'respostas/1-4.png',
                texto:'Na infância dos sócios'
              },
            ]
          },
          {
            titulo:'Quais são os principais pilares da empresa?',
            respostas:[
              {
                imagem:'respostas/1-1.png',
                texto:'Visão, audição, olfato, tato e paladar'
              },
              {
                imagem:'respostas/1-2.png',
                texto:'Criatividade, negatividade, e descaso com os clientes'
              },
              {
                imagem:'respostas/1-3.png',
                texto:'Visão, pessoas, marketing, tecnologia e criatividade'
              },
              {
                imagem:'respostas/1-4.png',
                texto:'Pessoas, grana fácil, e disputas empresariais'
              },
            ]
          },
        ],
      }
    },
    methods: {
      next(step) {
        this.$store.dispatch('integracao/setStep', step).then(() => {
          this.$router.push({name: 'integracao-' + this.$store.state.integracao.page});
        })
      },
      setEscolha(index){
        this.teste =  '';
        this.escolhas[this.perguntaAtual] = index;
        this.teste =  index;
        console.log('escolhas',this.escolhas)
        console.log('escolhas',this.escolhas)
      },
      backQuestion(){
        if (this.perguntaAtual - 1 >= 0)
        this.perguntaAtual = this.perguntaAtual - 1;
      },
      nextQuestion(){
        if (this.perguntaAtual + 1 < this.perguntas.length)
        this.perguntaAtual = this.perguntaAtual + 1;
      },
      finalizar(){
        localStorage.setItem('integracaoEscolhas',JSON.stringify({respostas:this.escolhas}))
        this.$router.push({name:'integracao-resultado'});
      },
      voltar(){
        this.$router.push({name:'integracao-avaliacaoinicio'});
      }
    },
    watch: {
      windowWidth() {
        this.width = window.innerWidth;
      }
    },
    computed: {
      userisloged(){
        let user = localStorage.getItem('integracaoLogged')
        return JSON.parse(user);
      },
      windowWidth() {
        return this.$store.state.windowWidth
      },
    }
  }
</script>


<style scoped>

  .pesquisa {
    background-image: url('../../assets/images/novaintegracao/bg-avalicao.png');
    background-size: cover;
    background-repeat: no-repeat no-repeat;
  }

  .btn-back {
    border: #fff 2px solid !important;
    color: #fff !important;
    background-color: transparent;
  }
  .header{
    width: 90%;
    margin: auto;
  }
  .mobile{
    display: none;
  }
  @media (max-width:600px){
    .descktop{
      display: none;
    }
    .mobile{
      display: block;
    }
   .card:hover{
    transform: scale(1);

}
}
</style>
